"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalComparisonComponent = void 0;
var React = require("react");
var configurationStyles_1 = require("../configurationStyles");
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../../gen-src/Localize");
var shakeInputIfInvalid_1 = require("../../../shakeIfInvalid/shakeInputIfInvalid");
var utils_1 = require("../../../utils");
var getNumberOfUnits = function (spec) {
    var _a;
    // This returns 1 in the case that the configuration component is initially rendered with
    // a null comparison. When that happens, we'd like to "default" to a default historical
    // comparison and not start in an error state.
    if (spec === null) {
        return 1;
    }
    if ((0, metrics_engine_1.isHistoricalComparisonSpec)(spec)) {
        return (_a = spec.numberOfPeriods) !== null && _a !== void 0 ? _a : 1;
    }
    return spec.numberOfMarks;
};
var HistoricalComparisonComponent = function (props) {
    if (props.selectedComparison !== null &&
        !(0, metrics_engine_1.isHistoricalComparisonSpec)(props.selectedComparison) &&
        !(0, metrics_engine_1.isMarkBasedComparison)(props.selectedComparison)) {
        return null;
    }
    var _a = React.useState(false), hasBeenEdited = _a[0], setEdited = _a[1];
    var _b = React.useState(getNumberOfUnits(props.selectedComparison)), numberOfUnits = _b[0], setNumberOfUnits = _b[1];
    var _c = React.useState((0, metrics_engine_1.shouldShowComparisonLine)(props.selectedComparison)), showComparisonLine = _c[0], setShowComparisonLine = _c[1];
    var updateStateValue = function (e) {
        setEdited(true);
        var reference = parseInt(e.target.value, 10);
        var value = isNaN(reference) ? undefined : reference;
        setNumberOfUnits(value);
    };
    var handleShowComparisonLineToggle = function (checked) {
        setShowComparisonLine(checked);
    };
    React.useEffect(function () {
        if (numberOfUnits !== undefined) {
            props.onSelectedComparisonChange((0, metrics_engine_1.makeMarkBasedOrHistoricalComparisonSpec)(numberOfUnits !== null && numberOfUnits !== void 0 ? numberOfUnits : undefined, (0, metrics_engine_1.dateTruncFromGranularity)(props.granularity), showComparisonLine));
        }
        else {
            props.onSelectedComparisonChange(null);
        }
    }, [numberOfUnits, showComparisonLine]);
    var onBlur = function () {
        setEdited(true);
    };
    var clearValue = function () {
        setNumberOfUnits(undefined);
    };
    var invalid = hasBeenEdited && !(0, metrics_engine_1.isValidHistoricalComparisonInput)(numberOfUnits !== null && numberOfUnits !== void 0 ? numberOfUnits : null);
    var inputRef = React.createRef();
    // On validation error, the widget shakes to grab the user's attention if it
    // doesn't have a valid value.  For this particular input, we only want to do
    // this if the value has been edited, since we don't want to an error state on
    // initial render.
    React.useEffect((0, shakeInputIfInvalid_1.shakeInputIfInvalid)(invalid, inputRef), [props.validationCounter]);
    var comparisonLineDisabled = !!props.disabled || props.granularity === metrics_engine_1.DateGranularity.UNKNOWN;
    return (React.createElement(React.Fragment, null,
        React.createElement(widgets_1.TextFieldWidget, { className: configurationStyles_1.comparisonInput, label: React.createElement("span", { style: { fontWeight: 'bold' } }, (0, utils_1.labelForGranularity)(props.granularity)), testId: "metric-granularity-units", onChange: updateStateValue, value: numberOfUnits !== null && numberOfUnits !== void 0 ? numberOfUnits : '', onClear: clearValue, onBlur: onBlur, valid: invalid ? false : undefined, message: invalid ? Localize_1.Messages.HistoricalComparisonInputErrorMessage() : React.createElement("br", null), ref: inputRef, min: metrics_engine_1.MINIMUM_COMPARISON_VALUE, max: metrics_engine_1.MAXIMUM_COMPARISON_VALUE, disabled: props.disabled }),
        React.createElement(widgets_1.CheckBoxWithLabelWidget, { label: Localize_1.Messages.ShowComparisonLineToggleLabel(), testId: "metric-show-comparison-line", checked: showComparisonLine !== null && showComparisonLine !== void 0 ? showComparisonLine : false, handleChange: handleShowComparisonLineToggle, removeLeftMargin: true, disabled: comparisonLineDisabled, style: { fontWeight: 'normal', marginBottom: '10px' } }),
        React.createElement("div", null)));
};
exports.HistoricalComparisonComponent = HistoricalComparisonComponent;
//# sourceMappingURL=HistoricalComparisonComponent.js.map